module.exports = __webpack_public_path__ + "static/media/badge-css3.a57aeaeb.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/badge-css3.png
// module id = 293
// module chunks = 0